<template>
  <div class="notification">
    <aha-logo
      width="140"
      height="32"
      class="aha-logo"
    />
    <h2>Can’t access AhaSlides add-on.</h2>
    <p>This might happen because you're logged into multiple Google accounts at once.</p>

    <h3>Try this:</h3>
    <ul class="fix-list">
      <li>Open Google Slides in incognito mode.</li>
      <li>Or log out of all Google accounts, then sign in only with the one connected to AhaSlides.</li>
    </ul>

    <aha-antd-button
      v-aha-emit-action
      name="openLearnMoreGoogleAddon"
      @click.stop="openLeanmore()"
    >
      {{ $i18nPresenter.t("Read full guide") }}
    </aha-antd-button>
    <p>
      Still need help? Email us at
      <a href="mailto:hi@ahaslides.com" class="text-primary-100 text-link">hi@ahaslides.com</a>.
    </p>
  </div>
</template>

<script>
export default {
  components: {
  },
  methods: {
    openLeanmore() {
      window.open('https://help.ahaslides.com/portal/en/kb/articles/using-the-ahaslides-add-on-in-google-slides#:~:text=If%20you%27re%20logged,If%20you%20open')
    },
  },
}
</script>

<style lang="scss" scoped>
.notification {
  max-width: 600px;
  padding: 16px;
  background-color: #fff;
  border-radius: 6px;
  font-family: Arial, sans-serif;
  line-height: 1.5;
  height: 100vh;
}

.notification h2 {
  margin-top: 0;
  margin-bottom: 12px;
  font-size: 1.3em;
  color: #333;
}

.notification p {
  margin: 12px 0;
  color: #555;
}

.notification h3 {
  margin: 16px 0 8px;
  font-size: 1.2em;
  color: #333;
}

.notification ol {
  margin: 0 0 16px 20px;
  padding: 0;
}

.notification ol li {
  margin-bottom: 8px;
  padding-left: 4px;
}

.notification a {
  text-decoration: none;
}

.notification a:hover {
  text-decoration: underline;
}
.fix-list {
  margin: 0 0 16px 24px;
  padding: 0;
  list-style-type: disc;      /* ensure bullet style */
}

.fix-list li {
  margin-bottom: 8px;
  padding-left: 4px;
}
.aha-logo {
  margin-top: 40px;
  margin-bottom: 16px;
}
</style>
